const PHRASE = "Sarthak ✦ Tanishka ✦ 22 · 11 · 2026 ✦ New Delhi ✦ ";

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative overflow-hidden border-y border-gold/15 bg-royal-surface/60 py-5"
        aria-hidden="true"
    >
        <div className="flex w-max animate-marquee">
            {[0, 1].map((copy) => (
                <span
                    key={copy}
                    className="whitespace-nowrap font-cinzel text-sm font-medium uppercase tracking-[0.5em] text-sand/90 sm:text-base"
                >
                    {PHRASE.repeat(4)}
                </span>
            ))}
        </div>
    </div>
);

export default Marquee;
